import React, { ReactElement } from "react";
import Content from "./Content";

export default function Ol(props: any): ReactElement {
  return (
    <ol style={{ marginBottom: "10px" }}>
      <Content contentValue={props.children} />
    </ol>
  );
}
